import React from 'react';
import { getSortIcon } from '../utils/tableUtils';
import { TableColumn, TableHeaderProps } from './TableHeader.types';

/**
 * Column configuration for the table header
 * Defines column keys, labels, and widths for consistent layout
 */
const COLUMNS: TableColumn[] = [
  { key: 'unicode', label: 'Юнікод', width: '13%' },
  { key: 'province', label: 'Область', width: '18%' },
  { key: 'brand', label: 'Бренд АЗК', width: '13%' },
  { key: 'address', label: 'Адреса', width: '36%' },
  { key: 'station_number', label: 'Номер АЗК', width: '10%' },
  { key: '', label: '', width: '10%' }
];

export function TableHeader({
  sortBy,
  sortOrder,
  onSort,
  isMobile = false,
  headerRef
}: TableHeaderProps & { isMobile?: boolean; headerRef?: React.Ref<HTMLDivElement> }) {
  if (isMobile) {
    return (
      <div className="azk-list-mobile-header-wrapper" ref={headerRef}>
        <table className="azk-list-table mobile-table" style={{ width: '100%', minWidth: '1200px' }}>
          <thead>
            <tr>
              {COLUMNS.map((col, index) => (
                <th
                  key={col.key || index}
                  className={`azk-list-header-cell ${col.key ? 'sortable' : ''} azk-list-header-cell-${col.key || 'actions'}`}
                  onClick={() => col.key && onSort(col.key)}
                >
                  {col.label}
                  {col.key && <div className="azk-list-sort-icon">{getSortIcon(sortBy, sortOrder, col.key)}</div>}
                </th>
              ))}
            </tr>
          </thead>
        </table>
      </div>
    );
  }

  return (
    <div className="azk-list-table-header">
      <div className="azk-list-header-row">
        {COLUMNS.map((col: TableColumn, index: number) => (
          <div
            key={col.key || index}
            className={`azk-list-header-cell ${col.key ? 'sortable' : ''} azk-list-header-cell-${col.key || 'actions'}`}
            onClick={() => col.key && onSort(col.key)}
          >
            {col.label}
            {col.key && <div className="azk-list-sort-icon">{getSortIcon(sortBy, sortOrder, col.key)}</div>}
          </div>
        ))}
      </div>
    </div>
  );
}
